<template>
	<!--(после скипа нужно выбрать kingOrGovernor)-->
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div ng-controller="questDialogCtrl" clickable="nextLine()" @click="onModalClose(close)" class="questDialogBG unselectable clickable">
			<div class="dialogActor position0 show" ng-class="{show: dialogStarted}">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_scout_illustration">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="emotion scout actor_scout_emotion__illustration">
				<div class="tooltip textBubble position0 after actor_scout show typetext" ng-class="{show: currentActor == 0}">
					<div class="tooltipContent ownText">
						<div ng-if="currentType != 'MC' || currentActor != 0">
							<div class="spokenText">Позвольте отметить это событие официальной декларацией.</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dialogActor position1 questGiverPortrait questGiver3" ng-class="{show: currentActor == 1}">
				<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_scout_illustration" data-cmp-info="10">
				<div class="tooltip textBubble position1 before actor_scout" ng-class="{show: currentActor == 1}">
					<div class="tooltipContent ownText">
						<div ng-if="currentType != 'MC'  || currentActor != 1">
							
						</div>
						<!-- ngIf: currentType == 'MC' && currentActor == 1 -->
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>